import { useEffect } from 'react';

type TobaccoAdvisoryProps = {
  closePopUp: any;
  popupProps: any;
};
declare global {
  interface Window {
    videojs: any;
  }
}
const TobaccoAdvisory = ({ closePopUp, popupProps }: TobaccoAdvisoryProps) => {
  useEffect(() => {
    const videoElement = document.getElementById('video-tag-tobaccoAdvisory');
    let advisoryVideoPlayer: any = null;
    if (typeof window !== 'undefined' && window?.videojs) {
      advisoryVideoPlayer = window.videojs(videoElement!, {}, undefined);
      advisoryVideoPlayer.src(popupProps.videoUrl);
    }
    if (advisoryVideoPlayer) {
      advisoryVideoPlayer.on('ended', function () {
        window.convivaSDK.reportPlaybackMetric(
          window.Conviva.Constants.Playback.PLAYER_STATE,
          window.Conviva.Constants.PlayerState.PAUSED
        );
        closePopUp();
      });
      advisoryVideoPlayer.on('playing', function () {
        window.convivaSDK.reportPlaybackMetric(
          window.Conviva.Constants.Playback.PLAYER_STATE,
          window.Conviva.Constants.PlayerState.PLAYING
        );
      });
      advisoryVideoPlayer.on('loadedmetadata', function () {
        const Component = window.videojs.getComponent('Component');
        /* Creating new wrapper component */
        const myWrapperComp = new Component(advisoryVideoPlayer);
        /* Adding wrapper component to player */
        advisoryVideoPlayer
          .addChild(myWrapperComp)
          .addClass('vjs-skip-wrapper');
        myWrapperComp.addChild('PlayToggle').addClass('vjs-playing');

        const audioTracks = window.videoPlayer.audioTracks();
        let contentVideoAudioLanguage = '';
        for (let i = 0; i < audioTracks.length; i++) {
          const track = audioTracks[i];
          if (track.enabled) {
            contentVideoAudioLanguage = track.language;
          }
        }
        const advisoryAudioTracks = advisoryVideoPlayer.audioTracks();
        for (let i = 0; i < advisoryAudioTracks.length; i++) {
          const track = advisoryAudioTracks[i];
          if (track.language === contentVideoAudioLanguage) {
            track.enabled = true;
          } else {
            track.enabled = false;
          }
        }
      });
    }
  }, []);
  return (
    <>
      <video
        className={`playerComp content video-js`}
        id="video-tag-tobaccoAdvisory"
        autoPlay
        muted
        controls
        playsInline
      />
    </>
  );
};

export default TobaccoAdvisory;
